<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Workflow History'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (loaded) {
      @if (workflowItems?.length == 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text [body]="'No workflows added yet. Add workflows to view the run history here.'" />
          </tidy-row>
        </tidy-alert>
      }
      @if (workflowItems?.length > 0) {
        <tidy-row>
          <tidy-filter
            [initValue]="selectedWorkflowValue"
            [items]="workflowItems"
            [fitContent]="true"
            (optionChange)="selectWorkflow($event)"
            class="align-center" />
        </tidy-row>
      }
      <tidy-row class="text-center">
        <tidy-header-datepicker
          (customDateOption)="selectCustomDateRange($event)"
          (stringDateOption)="selectStringDateRange($event)"
          [(dateRangeForm)]="dateRangeForm"
          [selectOptions]="selectOptions"
          [header]="false"
          [icon]="'assets/svg/calendar.svg'"
          class="secondary-layer fit-content" />
      </tidy-row>
      <tidy-row>
        <form [formGroup]="searchForm" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/svg/search-outline.svg'"
            class="header-search full-width" />
        </form>
      </tidy-row>
      @if (history?.length == 0 && workflowsLoaded) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'No history in this range.'" />
          </tidy-row>
        </tidy-alert>
      }
      @if (workflowsLoaded) {
        @for (run of history; track run) {
          <tidy-card>
            <tidy-card-button (action)="goToWorkflowRunPage(run)">
              <tidy-row class="vertical-align-middle">
                <tidy-text
                  [header]="run?.workflow_name" />
              </tidy-row>
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="run?.status === 'failed' ? 'assets/img/block.svg' : 'assets/img/checkmark.svg'"
                  class="body-size" />
                <tidy-text
                  [body]="run?.status | titlecase" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="(run?.status_updated_at | parseDateTime:'MMM d':'local') + ' ' + (run?.status_updated_at | parseDateTime:'h:mma':'local')" />
              </tidy-row>
            </tidy-card-button>
            @for (actionRun of run?.workflow_version_action_runs; track actionRun; let actionIndex = $index) {
              @if (actionRun?.input_values) {
                <tidy-row class="no-padding source-data-link-row">
                  <div class="source-data-link" (click)="toggleSourceData('run_' + run?.id + '_action_' + actionIndex)">
                    <tidy-text [body]="'View log data for '" />
                    <tidy-text [body]="actionRun?.action_name" />
                    <ion-icon
                      [name]="isSourceDataExpanded('run_' + run?.id + '_action_' + actionIndex) ? 'chevron-up' : 'chevron-down'"
                      class="source-data-icon" />
                  </div>
                </tidy-row>
                <tidy-row class="source-data-content"
                  [class.expanded]="isSourceDataExpanded('run_' + run?.id + '_action_' + actionIndex)"
                  [@slideAnimation]="isSourceDataExpanded('run_' + run?.id + '_action_' + actionIndex) ? 'expanded' : 'collapsed'">
                  <div class="source-data-inner">
                    @for (sourceItem of actionRun?.input_values | keyvalue; track sourceItem; let i = $index) {
                      <div [class]="'container bullet-item'" style="max-inline-size: 80%;">
                        <tidy-text [body]="'• ' + sourceItem.key + ': ' + utils.formatSourceDataValue(sourceItem.value)" />
                      </div>
                    }
                  </div>
                </tidy-row>
              }
            }
          </tidy-card>
        }
      }
      @if (!workflowsLoaded && history?.length > 0) {
        @for (item of [1,2,3,4,5,6,7,8,9,10]; track item) {
          <tidy-card>
            <tidy-card-button (action)="goToWorkflowRunPage(run)">
              <tidy-row class="vertical-align-middle" [alignLastItemRight]="true">
                <div style="width:20%">
                  <ion-skeleton-text animated style="width: 70%; height: 20px" />
                </div>
                <div style="width:15%; display: flex">
                  <ion-skeleton-text animated style="height: 40px" />
                  <ion-skeleton-text animated style="height: 40px" />
                </div>
                <div style="width:25%; margin-left:30px">
                  <ion-skeleton-text animated style="width: 80%; height: 20px" />
                  <ion-skeleton-text animated style="height: 20px" />
                </div>
                <div>
                </div>
              </tidy-row>
            </tidy-card-button>
          </tidy-card>
        }
      }
    }

    @if (!loaded) {
      <tidy-row class="extra-bottom-padding">
        <ion-skeleton-text animated="true" style="width: 150px; height: 36px; border-radius: 18px;" />
      </tidy-row>
      @for (item of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]; track item) {
        <tidy-card>
          <tidy-card-button (action)="goToWorkflowRunPage(run)">
            <tidy-row class="vertical-align-middle" [alignLastItemRight]="true">
              <div style="width:20%">
                <ion-skeleton-text animated style="width: 70%; height: 20px" />
              </div>
              <div style="width:15%; display: flex">
                <ion-skeleton-text animated style="height: 40px" />
                <ion-skeleton-text animated style="height: 40px" />
              </div>
              <div style="width:25%; margin-left:30px">
                <ion-skeleton-text animated style="width: 80%; height: 20px" />
                <ion-skeleton-text animated style="height: 20px" />
              </div>
              <div>
              </div>
            </tidy-row>
          </tidy-card-button>
        </tidy-card>
      }
    }

    @if (history?.length > 0) {
      <mat-paginator
        style="background: none"
        [length]="allHistoryLength"
        [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="selectPage($event)" />
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
